export const competitionStatusFilterTypes = {
  SHOW_ALL: 'SHOW_ALL',
  IN_PROGRESS: 'IN_PROGRESS',
  UNDER_APPROVAL: 'UNDER_APPROVAL',
  APPROVED: 'APPROVED',
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE'
}
